// extracted by mini-css-extract-plugin
module.exports = {"suggestion":"Suggestion_suggestion__f3WqD","suggestionLabel":"Suggestion_suggestionLabel__LAueZ","analysisText":"Suggestion_analysisText___iHdc"};